export const LOG_ACTIVITY_TYPE = {
    NEW_MESSAGE: '1',
    REACT : '2',
    UPDATE_MESSAGE :'3',
    READ_MESSAGE : '4',
    DELETE_MESSAGE :'5',
    UNREAD_MESSAGE :'6',
  }
  export const ROOT_REF_PATH = "Chats"

  export const LAST_TIME_LOG_REF_PATH = `${ROOT_REF_PATH}/MessagesLastTime`

